/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Public_TitleInputs */

const cs_settings_profile_public_title = /** @type {(inputs: Settings_Profile_Public_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veřejný titul`)
};

const en_settings_profile_public_title = /** @type {(inputs: Settings_Profile_Public_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public title`)
};

/**
* | output |
* | --- |
* | "Public title" |
*
* @param {Settings_Profile_Public_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_public_title = /** @type {((inputs?: Settings_Profile_Public_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Public_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_public_title(inputs)
	return cs_settings_profile_public_title(inputs)
});